const BaseURL = process.env.REACT_APP_BASE_URL;


const Endpoint = {
  auth: {
    login: "/admin/sign-in",
  },
  dashboard: {
    stats: "/admin/get-stats",
    graph: "/admin/get-transactions-graph",
  },
  customers: {
    getAllCustomers: "/admin/get-all-customers",
  },
  users: {
    activateUser: "/admin/activate-user",
    blockUser: "/admin/block-user",
  },
  suppliers: {
    getAllSuppliers: "/admin/get-all-suppliers",
  },
  transactions: {
    getAllTransactions: "/admin/get-all-transactions",
    transferPayment: "/admin/transfer-payment",
  },
  blogs: {
    createBlog: "/admin/create-blog",
    updateBlog: "/admin/update-blog",
    deleteBlog: "/admin/delete-blog",
    getAllBlogs: "/blogs/get-all-blogs",
  },
  policies: {
    createUpdatePolicies: "/admin/create-update-policy",
    getSinglePolicy: "/policies/get-single-policy",
  },
  support: {
    getAllSupportMessages: "/admin/get-all-support-messages",
    deleteSupportMessage: "/admin/delete-support-message",
  },
  newsLetter: {
    getAllNewsletterEmails: "/admin/get-all-newsletter-emails",
    deleteNewsletterEmail: "/admin/delete-newsletter",
  },
  settings: {
    updateProfile: "/admin/update-profile",
    updatePassword: "/admin/update-password",
  },
};

export { Endpoint, BaseURL, };
